import type { HTMLMotionProps } from 'motion/react'
import { motion } from 'motion/react'
import clsx from 'clsx'
import IconChevron from '../icons/IconChevron'
import { useSteleBreakpoint } from '@/src/hooks/useBreakpoint'

type TextButtonFlatProps = Omit<HTMLMotionProps<'a'>, 'children'> & {
    children: string
}

export default function TextButtonFlat({
    children,
    className,
    ...anchorProps
}: TextButtonFlatProps) {
    const isStele = useSteleBreakpoint()
    const animatedY = isStele ? -10 : -2.5

    return (
        <div
            className={clsx(
                'flex justify-center items-center bg-white-stroke rounded-full w-full',
                'h-8',
                'stele:h-32',
                className,
            )}
        >
            <motion.a
                {...anchorProps}
                initial={false}
                animate={{ y: animatedY }}
                whileTap={{ y: 0 }}
                transition={{
                    y: {
                        type: 'spring',
                        stiffness: 520,
                        damping: 30,
                        mass: 0.7,
                    },
                }}
                className={clsx(
                    'relative z-[2] flex justify-between items-center bg-white-gradient border-2 border-white-stroke rounded-full w-full h-full overflow-clip',
                    'pl-4 pr-2',
                    'stele:border-8 stele:pl-16 stele:pr-8',
                )}
            >
                <div
                    className={clsx(
                        'absolute bg-shine-gradient rounded-full mix-blend-screen opacity-65',
                        'top-1 left-3 right-3 h-2',
                        'stele:top-2 stele:left-12 stele:right-12 stele:h-8',
                    )}
                />
                <span
                    className={clsx(
                        'relative font-grandstander font-black italic text-white-stroke-darker uppercase leading-none truncate min-w-0',
                        'text-[12px] tracking-[0.24px]',
                        'stele:text-[48px] stele:tracking-[0.96px]',
                    )}
                >
                    {children}
                </span>
                <div
                    className={clsx(
                        'relative flex shrink-0 justify-center items-center',
                        'size-4',
                        'stele:size-16',
                    )}
                >
                    <IconChevron width='100%' height='100%' stroke='#5486AC' stopColor='#C8E3F7' />
                </div>
            </motion.a>
        </div>
    )
}
